var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListThumbsUpLightBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_1284_248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.3927 0.801987H8.55652C4.71675 0.801987 1.604 4.05363 1.604 8.06473V74.5373C1.604 78.5484 4.71675 81.8 8.55652 81.8H52.3927C56.2324 81.8 59.3452 78.5484 59.3452 74.5373V8.06473C59.3452 4.05363 56.2324 0.801987 52.3927 0.801987Z",
    fill: "white",
    stroke: "#0093C9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.7782 10.5199H14.4589C13.2232 10.5199 12.2214 11.5216 12.2214 12.7573C12.2214 13.993 13.2232 14.9947 14.4589 14.9947H46.7782C48.0139 14.9947 49.0156 13.993 49.0156 12.7573C49.0156 11.5216 48.0139 10.5199 46.7782 10.5199Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.6864 23.2966H9.55086C8.97911 23.2966 8.51562 23.76 8.51562 24.3318V24.4988C8.51562 25.0705 8.97911 25.534 9.55086 25.534H51.6864C52.2581 25.534 52.7216 25.0705 52.7216 24.4988V24.3318C52.7216 23.76 52.2581 23.2966 51.6864 23.2966Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.6864 32.5695H9.55086C8.97911 32.5695 8.51562 33.033 8.51562 33.6047V33.7717C8.51562 34.3434 8.97911 34.8069 9.55086 34.8069H51.6864C52.2581 34.8069 52.7216 34.3434 52.7216 33.7717V33.6047C52.7216 33.033 52.2581 32.5695 51.6864 32.5695Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.6864 41.2461H9.55086C8.97911 41.2461 8.51562 41.7096 8.51562 42.2813V42.4483C8.51562 43.0201 8.97911 43.4835 9.55086 43.4835H51.6864C52.2581 43.4835 52.7216 43.0201 52.7216 42.4483V42.2813C52.7216 41.7096 52.2581 41.2461 51.6864 41.2461Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.6864 50.8172H9.55086C8.97911 50.8172 8.51562 51.2807 8.51562 51.8525V52.0194C8.51562 52.5912 8.97911 53.0547 9.55086 53.0547H51.6864C52.2581 53.0547 52.7216 52.5912 52.7216 52.0194V51.8525C52.7216 51.2807 52.2581 50.8172 51.6864 50.8172Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M51.6864 60.6865H9.55086C8.97911 60.6865 8.51562 61.15 8.51562 61.7217V61.8887C8.51562 62.4604 8.97911 62.9239 9.55086 62.9239H51.6864C52.2581 62.9239 52.7216 62.4604 52.7216 61.8887V61.7217C52.7216 61.15 52.2581 60.6865 51.6864 60.6865Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.6864 69.3631H9.55086C8.97911 69.3631 8.51562 69.8266 8.51562 70.3983V70.5653C8.51562 71.137 8.97911 71.6005 9.55086 71.6005H51.6864C52.2581 71.6005 52.7216 71.137 52.7216 70.5653V70.3983C52.7216 69.8266 52.2581 69.3631 51.6864 69.3631Z",
    fill: "#0093C9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.9249 57.8879C72.919 57.8879 82.6421 48.1648 82.6421 36.1707C82.6421 24.1767 72.919 14.4536 60.9249 14.4536C48.9309 14.4536 39.2078 24.1767 39.2078 36.1707C39.2078 48.1648 48.9309 57.8879 60.9249 57.8879Z",
    fill: "#0093C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5718 45.3557L58.3381 45.3483L55.9438 44.8709C55.9483 44.8154 55.951 44.7594 55.951 44.7027V34.3272L56.1374 34.2139L58.4073 29.8443C59.3382 28.052 57.941 24.4508 60.5198 23.8839C62.8452 23.3729 65.2767 26.4911 62.9665 32.774L70.6213 32.7782C72.8468 33.1187 72.8513 35.5234 71.1735 36.3631C71.9291 37.2167 71.8173 38.5981 70.8664 39.2329C71.6661 40.083 71.5719 41.5073 70.6052 42.1504C71.5644 43.1717 71.2317 45.0173 69.6505 45.348C69.6249 45.3533 69.5983 45.3563 69.5721 45.3563L69.5718 45.3557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9654 45.9199H50.6966C50.0254 45.9199 49.4795 45.3736 49.4795 44.7027V34.3325C49.4795 33.6614 50.0254 33.1154 50.6966 33.1154H53.9654C54.6366 33.1154 55.1828 33.6614 55.1828 34.3325V44.703C55.1828 45.3745 54.6366 45.9202 53.9654 45.9202V45.9199Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6422,
    height: 83,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListThumbsUpLightBlue);
export default __webpack_public_path__ + "static/media/list-thumbs-up-lightBlue.23d942a49273529abc94f44510ba1a00.svg";
export { ForwardRef as ReactComponent };